import React from 'react';
import skillsVideo from '@/images/skills.mp4';

const SkillsSection = () => {
  const skills = [
    { name: 'UI/UX Design' },
    { name: 'Figma' },
    { name: 'HTML/CSS' },
    { name: 'JavaScript' },
    { name: 'React' },
    { name: 'TypeScript' },
    { name: 'Tailwind CSS' },
    { name: 'Responsive Design' },
  ];

  return (
    <section id="skills" className="relative py-20 overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 w-full h-full z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        >
          <source src={skillsVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-black/60" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h5 className="text-primary mb-2 font-Urbanist font-medium tracking-widest text-xl flex">My Expertise</h5>
          <h2 className="section-heading font-light tracking-widest sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-white">
            My Skills in Action✌️
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {skills.map((skill, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-sm p-6 rounded-lg border border-white/20 flex justify-center items-center">
              <span className="text-white font-medium">{skill.name}</span>
              
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-white/80 mb-6 max-w-2xl mx-auto text-lg">
            I continuously refine my skills to deliver exceptional digital experiences that blend creativity with functionality.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;
